import React, {ReactNode} from 'react';
import { styled, css } from '@mui/system';
import { Modal as BaseModal } from '@mui/base/Modal';
import Fade from '@mui/material/Fade';

interface FreeTieModalProps {
	open: boolean;
	handleClose: () => void;
	children: ReactNode;
}

const FreeTieModal = (props: FreeTieModalProps) => {
	return (
		<Modal
			aria-labelledby="transition-modal-title"
			aria-describedby="transition-modal-description"
			open={props.open}
			onClose={props.handleClose}
			closeAfterTransition
			slots={{ backdrop: StyledBackdrop }}
		>
			<Fade in={props.open}>
				<ModalContent sx={style}>
					{props.children}
				</ModalContent>
			</Fade>
		</Modal>
	);
};

const Backdrop = React.forwardRef<HTMLDivElement, { open?: boolean }>(
	(props, ref) => {
		const { open, ...other } = props;
		return (
			<Fade in={open}>
				<div ref={ref} {...other} />
			</Fade>
		);
	},
);

const Modal = styled(BaseModal)`
  position: fixed;
  z-index: 1300;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 0.5);
  -webkit-tap-highlight-color: transparent;
`;

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '100%',
};

const ModalContent = styled('div')(
	({ theme }) => css``,
);


export default FreeTieModal;